export interface InDevCourse {
  slug: string;
  title: string;
  description: string;
  backgroundPattern: string;
  price: string;
  targetLevel: string;
  durationHours: number;
  highlights: string[];
  forWhom: string;
  expertiseNote: string;
}

export const IN_DEV_COURSES: InDevCourse[] = [
  {
    slug: "clickhouse-advanced",
    title: "ClickHouse Advanced",
    description:
      "Курс для тех, кто уже пишет запросы и хочет понять, почему они работают медленно — и как это исправить. Глубокое погружение в архитектуру MergeTree, стратегии партиционирования, репликацию и распределённые кластеры.",
    backgroundPattern: "bg-gradient-to-br from-indigo-400 via-purple-500 to-pink-500",
    price: "от 4 990 руб/мес.",
    targetLevel: "Middle / Senior",
    durationHours: 12,
    highlights: [
      "Архитектура MergeTree изнутри: мержи, мутации, TTL",
      "Партиционирование: стратегии, подводные камни, best practices",
      "Репликация и шардирование на реальных кластерах",
      "EXPLAIN PIPELINE: читать план запроса как книгу",
      "Проектирование схем под аналитические нагрузки 100M+ строк",
      "Materialized Views как инструмент архитектора",
    ],
    forWhom:
      "Аналитики и инженеры, которые знают базовый SQL в ClickHouse и хотят выйти на уровень, где можно проектировать системы, а не только писать запросы.",
    expertiseNote:
      "Курс основан на паттернах из production-систем с нагрузкой от 10 млрд событий в сутки.",
  },
  {
    slug: "clickhouse-bi",
    title: "ClickHouse для BI",
    description:
      "Практический курс о том, как строить надёжные BI-слои поверх ClickHouse — от модели данных до дашборда в Metabase, Grafana или Superset. Без лишней теории: только то, что нужно для работающих метрик.",
    backgroundPattern: "bg-gradient-to-br from-cyan-400 via-blue-500 to-indigo-500",
    price: "от 4 990 руб/мес.",
    targetLevel: "Analyst / Middle",
    durationHours: 10,
    highlights: [
      "Модели данных для BI: star schema, wide table, агрегаты",
      "Materialized Views для мгновенного ответа дашборда",
      "Подключение Metabase, Grafana, Superset к ClickHouse",
      "Оконные функции для продуктовых метрик: retention, DAU, LTV",
      "Когортный анализ и воронки на реальных данных",
      "Оптимизация под конкурентные запросы от 50+ пользователей",
    ],
    forWhom:
      "Продуктовые аналитики и BI-инженеры, которые хотят строить быстрые дашборды и не объяснять менеджерам, почему отчёт считается 30 секунд.",
    expertiseNote: "Включает шаблоны метрик из e-commerce, SaaS и мобильных продуктов.",
  },
  {
    slug: "clickhouse-optimization",
    title: "Оптимизация ClickHouse",
    description:
      "Курс о том, как сделать запросы быстрее в 10–100 раз без смены железа. Учимся читать профили выполнения, проектировать индексы и понимать, где ClickHouse тормозит и почему.",
    backgroundPattern: "bg-gradient-to-br from-emerald-400 via-green-500 to-teal-500",
    price: "от 4 990 руб/мес.",
    targetLevel: "Middle / Senior",
    durationHours: 8,
    highlights: [
      "Первичные и вторичные индексы: как работают, когда помогают",
      "Гранулы, засечки и bloom filter в деталях",
      "Профилирование через system.query_log и flame graph",
      "Сжатие данных: ZSTD, Gorilla, DoubleDelta — что выбрать",
      "Проекции как замена агрегирующих таблиц",
      "Типичные анти-паттерны и как их найти в чужом коде",
    ],
    forWhom:
      "Инженеры и аналитики, у которых есть запросы с временем выполнения больше 1 секунды и желание разобраться, почему.",
    expertiseNote:
      "Каждая тема подкреплена бенчмарками на реальных датасетах от 500M строк.",
  },
];
